export default __webpack_public_path__ + "static/media/scw-grid-9.cac09bc0.svg";